import sendSegmentEvent from '@client/utils/segmentHelper'
import sendOptimizelyCustomEvent from '@client/utils/optimizelyHelper'

const formSubmitedEvent = country => {
  const countryUppercase = country.toUpperCase()
  const optimizelyEventName = `company_info_b2b_lead_created_${country}`

  sendSegmentEvent('page_clicked', {
    click_cta: 'request_proposal',
    component_category: 'company_info_form',
    component_position: 'unique',
    country_name: countryUppercase,
    event_category: 'unlogged_enterprise',
    page_name: 'company_info',
  })
  sendOptimizelyCustomEvent(optimizelyEventName, {
    component_category: 'company_info_form',
    country_name: countryUppercase,
    event_category: 'unlogged_enterprise',
    page_name: 'company_info',
  })
  sendOptimizelyCustomEvent('company_info_b2b_lead_created', {
    component_category: 'company_info_form',
    country_name: countryUppercase,
    event_category: 'unlogged_enterprise',
    page_name: 'company_info',
  })
}

export default formSubmitedEvent
